import React from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const DEFAULT_ELEMENT = 'section'
const BASE_CLASS = 'mt-SectionBasic'
const TITLE_CLASS = `${BASE_CLASS}-title`
const MARGINS = {
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl',
  xxl: 'xxl',
  xxxl: 'xxxl',
  giant: 'giant'
}

const SectionBasic = ({
  children,
  description,
  el: Element = DEFAULT_ELEMENT,
  id,
  margin = MARGINS.l,
  title,
  titleMargin = MARGINS.m,
  titleSize = titleBasicSizes.xs
}) => {
  const hasTitle = Boolean(title)
  const elementClassName = cx(BASE_CLASS, `${BASE_CLASS}-margin--${margin}`)
  const titleClassName = cx(TITLE_CLASS, `${TITLE_CLASS}-margin--${titleMargin}`)

  return (
    <Element className={elementClassName} id={id}>
      {hasTitle ? (
        <div className={titleClassName}>
          <TitleBasic
            as={titleBasicTags.h2}
            title={title}
            size={titleBasicSizes[titleSize]}
            description={description}
          />
        </div>
      ) : null}
      {children}
    </Element>
  )
}

SectionBasic.displayName = 'SectionBasic'
SectionBasic.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  el: PropTypes.string,
  id: PropTypes.string,
  margin: PropTypes.oneOf(Object.values(MARGINS)),
  title: PropTypes.string,
  titleMargin: PropTypes.oneOf(Object.values(MARGINS)),
  titleSize: PropTypes.string
}

export {MARGINS as sectionBasicMargins}
export default SectionBasic
